let _isEmpty = function(text) {
    return text.trim().length === 0;
};

let _hasInvalidCharacters = function(text) {
    return text.match(/^[/\w\-–().:;,!?""”''´`åäöÅÄÖ€+\s$ ]+$/) === null;
};

let _hasInvalidLength = function(minLength, maxLength, text) {
    return !(text.length > minLength && text.length <= maxLength);
};

let _hasReturnChar = function(msg) {
    return msg.match(/\r|\n/);
};

export default {
    hasInvalidCharacters: _hasInvalidCharacters,
    isEmpty: _isEmpty,
    hasInvalidLength: _hasInvalidLength,
    hasReturnChar: _hasReturnChar
};
